import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/authContext";
import { volverAClase } from "../utils/navigation";

const Historial = () => {
  const [entrenos, setEntrenos] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success");
  const [confirmMode, setConfirmMode] = useState(false); // 🔹 modo confirmación
  const navigate = useNavigate();
  const { user } = useAuth();


  //Validar que estoy en historial
  useEffect(() => {
    localStorage.setItem("lastPage", "historial");
  }, []);


  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("historialEntrenos")) || [];
    const ordenados = [...data].reverse();
    setEntrenos(ordenados);
  }, []);

  const handleClear = () => {
    localStorage.removeItem("historialEntrenos");
    setEntrenos([]);

    // ✅ mensaje de éxito
    setModalType("success");
    setModalMessage("✅ Historial borrado con éxito");
    setConfirmMode(false);
    setModalOpen(true);
  };

  const openConfirmModal = () => {
    setModalType("error");
    setModalMessage("⚠️ ¿Seguro que deseas borrar el historial?");
    setConfirmMode(true);
    setModalOpen(true);
  };

    return (
    <div className="w-screen min-h-screen bg-gradient-to-br from-gray-950 via-black to-gray-900 text-white">
      <div className="w-full max-w-md mx-auto px-4 pt-5 pb-10">

        {/* CABECERA */}
        <div className="flex items-center justify-between gap-3 mb-6">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-green-400">
              Tu progreso
            </p>

            <h1 className="mt-1 text-3xl font-black">
              Historial de entrenos
            </h1>

            <p className="mt-2 text-sm text-gray-400">
              {entrenos.length === 0
                ? "Todavía no tienes sesiones guardadas."
                : `${entrenos.length} ${
                    entrenos.length === 1
                      ? "sesión guardada"
                      : "sesiones guardadas"
                  }`}
            </p>
          </div>

          <div className="w-14 h-14 shrink-0 flex items-center justify-center rounded-2xl border border-green-400/20 bg-green-500/10 text-2xl shadow-lg">
            📊
          </div>
        </div>

        {/* ESTADO VACÍO */}
        {entrenos.length === 0 ? (
          <div className="rounded-3xl border border-white/10 bg-white/5 p-7 text-center shadow-xl">
            <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-3xl bg-white/10 text-3xl">
              🚴
            </div>

            <h2 className="mt-5 text-xl font-extrabold text-white">
              Aún no hay entrenos
            </h2>

            <p className="mt-2 text-sm leading-6 text-gray-400">
              Completa una sesión y guárdala para ver aquí tus métricas y tu progreso.
            </p>

            <button
              type="button"
              onClick={() => volverAClase(navigate, user?.uid)}
              className="w-full mt-6 py-4 rounded-2xl bg-gradient-to-r from-green-400 to-emerald-600 text-white font-extrabold shadow-xl"
            >
              Volver a entrenar
            </button>
          </div>
        ) : (
          <div className="space-y-4">
            {entrenos.map((entreno, index) => {
              const esPremium = entreno.modo === "Premium";

              return (
                <motion.article
                  key={index}
                  initial={{
                    opacity: 0,
                    y: 20,
                  }}
                  animate={{
                    opacity: 1,
                    y: 0,
                  }}
                  transition={{
                    delay: index * 0.06,
                    duration: 0.3,
                  }}
                  className="overflow-hidden rounded-3xl border border-white/10 bg-white/[0.07] shadow-xl backdrop-blur-lg"
                >
                  {/* CABECERA TARJETA */}
                  <div className="flex items-start justify-between gap-3 p-5 pb-4">
                    <div>
                      <p className="text-xs uppercase tracking-widest text-gray-500">
                        Sesión guardada
                      </p>

                      <h2 className="mt-1 text-lg font-extrabold text-white">
                        {entreno.fecha}
                      </h2>
                    </div>

                    <span
                      className={`
                        shrink-0
                        rounded-full
                        border
                        px-3
                        py-1.5
                        text-[10px]
                        font-black
                        uppercase
                        tracking-wider
                        ${
                          esPremium
                            ? "border-yellow-400/20 bg-yellow-500/10 text-yellow-300"
                            : "border-blue-400/20 bg-blue-500/10 text-blue-300"
                        }
                      `}
                    >
                      {esPremium ? "Premium" : "Modo libre"}
                    </span>
                  </div>

                  {/* MÉTRICAS PRINCIPALES */}
                  <div className="grid grid-cols-3 gap-2 px-5">
                    <div className="rounded-2xl border border-white/10 bg-black/20 px-2 py-3 text-center">
                      <p className="text-lg">⏱️</p>

                      <p className="mt-1 text-sm font-extrabold text-white">
                        {entreno.duracion}
                      </p>

                      <p className="mt-1 text-[10px] uppercase tracking-wider text-gray-500">
                        Duración
                      </p>
                    </div>

                    <div className="rounded-2xl border border-white/10 bg-black/20 px-2 py-3 text-center">
                      <p className="text-lg">🚴</p>

                      <p className="mt-1 text-sm font-extrabold text-blue-400">
                        {entreno.distancia}
                      </p>

                      <p className="mt-1 text-[10px] uppercase tracking-wider text-gray-500">
                        Distancia
                      </p>
                    </div>

                    <div className="rounded-2xl border border-white/10 bg-black/20 px-2 py-3 text-center">
                      <p className="text-lg">🔥</p>

                      <p className="mt-1 text-sm font-extrabold text-orange-400">
                        {entreno.calorias}
                      </p>

                      <p className="mt-1 text-[10px] uppercase tracking-wider text-gray-500">
                        Calorías
                      </p>
                    </div>
                  </div>

                  {/* DATOS SECUNDARIOS */}
                  <div className="grid grid-cols-2 gap-2 px-5 mt-3">
                    <div className="rounded-2xl border border-green-400/10 bg-green-500/5 px-3 py-3">
                      <p className="text-[10px] uppercase tracking-wider text-gray-500">
                        Puntos
                      </p>

                      <p className="mt-1 text-lg font-extrabold text-green-400">
                        {entreno.puntos || 0}
                      </p>
                    </div>

                    <div className="rounded-2xl border border-purple-400/10 bg-purple-500/5 px-3 py-3">
                      <p className="text-[10px] uppercase tracking-wider text-gray-500">
                        Reacciones
                      </p>

                      <p className="mt-1 text-lg font-extrabold text-purple-300">
                        {entreno.emojis || 0}
                      </p>
                    </div>
                  </div>

                  {/* RPM */}
                  {entreno.cadenciaMedia !== undefined && (
                    <div className="mx-5 mt-3 flex items-center justify-between rounded-2xl border border-white/10 bg-black/20 px-4 py-3">
                      <div>
                        <p className="text-[10px] uppercase tracking-wider text-gray-500">
                          RPM registradas
                        </p>

                        <p className="mt-1 text-sm text-gray-300">
                          Cadencia al guardar la sesión
                        </p>
                      </div>

                      <span className="text-xl font-extrabold text-yellow-300">
                        {entreno.cadenciaMedia}
                      </span>
                    </div>
                  )}

                  {/* GIMNASIO Y CLASE */}
                  {(entreno.gimnasio || entreno.claseId) && (
                    <div className="mx-5 mt-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-3">
                      {entreno.gimnasio && (
                        <div className="flex items-center justify-between gap-3">
                          <span className="text-xs text-gray-500">
                            Gimnasio
                          </span>

                          <span className="truncate text-sm font-bold text-white">
                            {entreno.gimnasio}
                          </span>
                        </div>
                      )}

                      {entreno.claseId && (
                        <div
                          className={`flex items-center justify-between gap-3 ${
                            entreno.gimnasio
                              ? "mt-2 border-t border-white/10 pt-2"
                              : ""
                          }`}
                        >
                          <span className="text-xs text-gray-500">
                            Clase
                          </span>

                          <span className="truncate text-sm font-bold text-white">
                            {entreno.claseId}
                          </span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* PIE */}
                  <div className="mt-5 flex items-center justify-between border-t border-white/10 px-5 py-4">
                    <span className="text-xs text-gray-500">
                      Entreno #{entrenos.length - index}
                    </span>

                    <span
                      className={`text-xs font-bold ${
                        esPremium
                          ? "text-yellow-300"
                          : "text-blue-300"
                      }`}
                    >
                      {esPremium
                        ? "Sesión con clase"
                        : "Entrenamiento libre"}
                    </span>
                  </div>
                </motion.article>
              );
            })}
          </div>
        )}

        {/* ACCIONES */}
        <div className="mt-7">
          <button
            type="button"
            onClick={() => volverAClase(navigate, user?.uid)}
            className="w-full py-4 rounded-2xl bg-gradient-to-r from-green-400 to-emerald-600 text-white font-extrabold shadow-xl"
          >
            🚴 Volver a la app
          </button>

          {entrenos.length > 0 && (
            <div className="mt-4 rounded-3xl border border-white/10 bg-white/5 p-4">
              <p className="text-xs uppercase tracking-widest text-gray-500">
                Gestión del historial
              </p>

              <p className="mt-2 text-sm leading-6 text-gray-400">
                Esta acción eliminará todos los entrenos guardados en este dispositivo.
              </p>

              <button
                type="button"
                onClick={openConfirmModal}
                className="w-full mt-4 py-3 rounded-xl border border-red-400/20 bg-red-500/10 text-sm font-bold text-red-400 transition active:bg-red-500/20"
              >
                Borrar historial
              </button>
            </div>
          )}
        </div>

        {/* FRASE */}
        <p className="mt-7 text-center text-xs italic text-gray-500">
          El progreso se construye entreno a entreno 🚴🔥
        </p>
      </div>

      {/* MODAL */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 px-4 backdrop-blur-sm">
          <motion.div
            initial={{
              opacity: 0,
              scale: 0.9,
              y: 15,
            }}
            animate={{
              opacity: 1,
              scale: 1,
              y: 0,
            }}
            className="w-full max-w-sm rounded-3xl border border-white/10 bg-gradient-to-br from-gray-900 via-black to-gray-800 p-6 text-center text-white shadow-2xl"
          >
            <div
              className={`
                mx-auto
                flex
                h-14
                w-14
                items-center
                justify-center
                rounded-2xl
                text-2xl
                ${
                  modalType === "success"
                    ? "bg-green-500/20"
                    : "bg-red-500/20"
                }
              `}
            >
              {modalType === "success" ? "✅" : "⚠️"}
            </div>

            <h2
              className={`mt-4 text-lg font-extrabold ${
                modalType === "success"
                  ? "text-green-400"
                  : "text-red-400"
              }`}
            >
              {modalMessage}
            </h2>

            {confirmMode ? (
              <div className="mt-6 grid grid-cols-2 gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setConfirmMode(false);
                    setModalOpen(false);
                  }}
                  className="py-3 rounded-2xl border border-white/10 bg-white/5 font-bold text-gray-300"
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  onClick={handleClear}
                  className="py-3 rounded-2xl bg-red-600 font-extrabold text-white shadow-lg"
                >
                  Sí, borrar
                </button>
              </div>
            ) : (
              <button
                type="button"
                onClick={() => setModalOpen(false)}
                className="w-full mt-6 py-3 rounded-2xl bg-white font-extrabold text-black"
              >
                Entendido
              </button>
            )}
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default Historial;